var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUparrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13799",
    "data-name": "Group 13799",
    transform: "translate(-1829 -2645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5267",
    "data-name": "Rectangle 5267",
    transform: "translate(1829 2645)",
    fill: "rgba(var(--secondaryColorRGB) , 0.25)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13799-2",
    "data-name": "Group 13799",
    transform: "translate(2070.334 846.594) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M11327.272,6262.939h-19.734",
    transform: "translate(-9499 -6041.605)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11113",
    "data-name": "Path 11113",
    d: "M11141.923,6321.765l-4.976,4.976,4.976,4.975",
    transform: "translate(-9328.409 -6105.406)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow2);
export default __webpack_public_path__ + "static/media/Uparrow2.be81a72a6b62156584bff262279fad99.svg";
export { ForwardRef as ReactComponent };